function Verticals() {
    return (
        <div className="verticals">
        </div>
    );
}

export default Verticals;
